import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: NotificationState = {
    showNoNetworkBanner: false,
    alerts: [],
    modals: []
};

const notificationSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        pushModal(state, action: PayloadAction<ModalProp>) {
            state.modals.unshift(action.payload);
        },
        popModal(state, action: PayloadAction<string | number>) {
            state.modals = state.modals.filter((m) => m.id !== action.payload);
        },
        clearModals(state) {
            state.modals = [];
        },
        pushAlert(state, action: PayloadAction<AlertProp>) {
            state.alerts.unshift(action.payload);
        },
        popAlert(state, action: PayloadAction<string | number>) {
            state.alerts = state.alerts.filter((a) => a.id !== action.payload);
        },
        clearAlerts(state) {
            state.alerts = [];
        },
        showNetworkBanner(state) {
            state.showNoNetworkBanner = true;
        },
        hideNetworkBanner(state) {
            state.showNoNetworkBanner = false;
        }
    }
});

export const {
    pushModal,
    popModal,
    clearModals,
    pushAlert,
    popAlert,
    clearAlerts,
    showNetworkBanner,
    hideNetworkBanner
} = notificationSlice.actions;
export default notificationSlice.reducer;
